var DependentsListDataTestIdEnum = /* @__PURE__ */ ((DependentsListDataTestIdEnum2) => {
  DependentsListDataTestIdEnum2["DEPENDENTS_LIST_ADD_DEPENDENT_BUTTON"] = "dependents-list-add-dependent-button";
  return DependentsListDataTestIdEnum2;
})(DependentsListDataTestIdEnum || {});
export {
  DependentsListDataTestIdEnum
};
